import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';

import bulkRequestKeys from '@app/features/bulkRequest/queryKey';
import coalesceGlobalErrorMessage from '@app/libs/coalesceGlobalErrorMessage';
import { modalOpen } from '@app/store/modal/actions';
import { putBulkRequestsSigningDuration } from '@app/store/transport-layer/bulk-request/bulk-requests/signing-duration';

const useUpdateBulkRequestSigningDuration = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation<void, Error, Parameters<typeof putBulkRequestsSigningDuration>>(
    (vs) => putBulkRequestsSigningDuration(...vs),
    {
      onSuccess: (_, [, bulkRequestId]) => {
        queryClient.invalidateQueries(bulkRequestKeys.query.byId(bulkRequestId));
      },
      onError: (error) => {
        dispatch(
          modalOpen('CONFIRM', {
            title: '대량전송 서명 유효기간 수정 실패',
            content: coalesceGlobalErrorMessage(error.message),
          })
        );
      },
    }
  );
};

export default useUpdateBulkRequestSigningDuration;
